import { IntlFormatters } from "react-intl";

const genreMessages = {
    childrensong: {
        id: "meta.apparatus.vocal.childrensong",
    },
    song: {
        id: "meta.apparatus.vocal.song",
    },
    choir: {
        id: "meta.apparatus.vocal.choir",
    },
    solo: {
        id: "meta.apparatus.instrumental.solo",
    },
    chamber: {
        id: "meta.apparatus.instrumental.chamber",
    },
    orchestra: {
        id: "meta.apparatus.instrumental.orchestra",
    },
    oratoric: {
        id: "meta.apparatus.mixed.oratoric",
    },
    opera: {
        id: "meta.apparatus.mixed.opera",
    },
    songDetails: {
        id: "meta.apparatus.vocal.song.details",
    },
    choirDetails: {
        id: "meta.apparatus.vocal.choir.details",
    },
    soloDetails: {
        id: "meta.apparatus.instrumental.solo.details",
    },
    chamberDetails: {
        id: "meta.apparatus.instrumental.chamber.details",
    },
    orchestraDetails: {
        id: "meta.apparatus.instrumental.orchestra.details",
    },
    oratoricDetails: {
        id: "meta.apparatus.mixed.oratoric.details",
    },
    operaDetails: {
        id: "meta.apparatus.mixed.opera.details",
    },
};

export const generalGenres = (fm: IntlFormatters["formatMessage"]) => {
    return [
        {
            value: "choir",
            label: fm(genreMessages["choir"]),
            details: fm(genreMessages["choirDetails"]),
            img: "choir.jpg",
        },
        {
            value: "orchestra",
            label: fm(genreMessages["orchestra"]),
            details: fm(genreMessages["orchestraDetails"]),
            img: "orchestra.jpg",
        },
        {
            value: "chamber",
            label: fm(genreMessages["chamber"]),
            details: fm(genreMessages["chamberDetails"]),
            img: "chamber.jpg",
        },
        { value: "solo", label: fm(genreMessages["solo"]), details: fm(genreMessages["soloDetails"]), img: "solo.jpg" },
        {
            value: "oratoric",
            label: fm(genreMessages["oratoric"]),
            details: fm(genreMessages["oratoricDetails"]),
            img: "oratorio.jpg",
        },
        {
            value: "opera",
            label: fm(genreMessages["opera"]),
            details: fm(genreMessages["operaDetails"]),
            img: "opera.jpg",
        },
        {
            value: "song",
            label: fm(genreMessages["song"]),
            details: fm(genreMessages["songDetails"]),
            img: "singer.jpg",
        },
    ];
};
